
/* System defined core library */
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import * as moment from 'moment';
import { UtilityService } from '../../services/utility.service';
import '@progress/kendo-ui'

/* User defined enums/constants */
import { regex } from '../../../shared/constants/scheduling.constant';

@Component({
  selector: 'datepicker-demo',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements AfterViewInit, OnChanges, OnInit {

  /* User defined private/public variables  */
  public dt: any = new Date();
  public minDate: Date = void 0;
  public events: any[];
  public dateDisabled: { date: Date, mode: string }[];
  public currentDate: any;
  private opened: boolean = false;
  private options: kendo.ui.DatePickerOptions;
  public lastDateCell: HTMLElement;
  public preventClose: boolean = false;

  @ViewChild('datepickerInput') datepickerInput: ElementRef;

  /* Input-OutPut parameters decalartions */
  @Input() public showSelectedDate: boolean = false;
  @Input() public activeDate: any;
  @Input() public endDate: any;
  @Input() public placeholderText: string;
  @Input() public id: string;
  @Input() public selectionMode: string;
  @Input() public toggleCalendar: boolean = false;
  @Input() public startDate: any;
  @Input() public myStartOptions: any;
  @Input() public myEndOptions: any;
  @Input() public disabled: boolean;
  @Output() public isSlotSelected: EventEmitter<boolean> = new EventEmitter();
  @Output() public SelectedStartDate = new EventEmitter<any>();
  @Output() public SelectedEndDate: EventEmitter<any> = new EventEmitter();
  @Output() public datepickerInputRef: EventEmitter<ElementRef> = new EventEmitter();
  @Input() public parent: string;
  @Input() public section: string;
  @Input() public defaultMonth: string;
  @Input() public describedBy: string;
  @Input() public preventCloseOnSelect: boolean = false;
  @Input() public datepickerBtnAriaLblText: string;
  @Input() public datepickerDialogAriaLblText: string;

  /* Constructor declaration with required injected services */
  public constructor(private utilityService: UtilityService) {
    (this.minDate = new Date());
    (this.dateDisabled = []);
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    if (this.selectionMode == 'start') {
      this.options = this.myStartOptions;
    }
    else {
      this.options = this.myEndOptions;
    }
  }

  ngAfterViewInit() {
    this.datepickerInputRef.emit(this.datepickerInput);

    $(`#${this.id}`).kendoDatePicker({
      min: this.options.min,
      max: this.options.max,
      format: this.options.format,
      value: this.getSelectedDate(),
      dateInput: true,
      start: this.options.start,
      disableDates: this.options.disableDates,
      messages: {
        dateInput: {
          year: "YYYY",
          month: "MM",
          day: "DD"
        }
      },
      footer: false,
      change: () => this.onSelectionDone(),
      close: (e) => this.onCalendarClose(e),
      open: () => this.onCalendarOpen()
    });

    $(`#${this.id}`).data("kendoDatePicker").enable(!this.disabled);
    $(`#${this.id}`).siblings('button').attr('aria-label', `${this.datepickerBtnAriaLblText}`);
  }

   public onCalendarOpen(): void {
      setTimeout(() => {
        $('.k-animation-container[role="region"]').attr('aria-label', `${this.datepickerDialogAriaLblText}`);
        $('.k-animation-container[role="region"]').attr('role', "dialog");
      }, 500);
   }

  /* Emit selected date to parent if any change */
  public onSelectionDone(): void {
    this.preventClose = this.preventCloseOnSelect;

    let dpValue = $(`#${this.id}`).data("kendoDatePicker").value();

    if (!!dpValue) {
      let selectedDate = {
        date: {
          year: dpValue.getFullYear(),
          month: dpValue.getMonth() + 1,
          day: dpValue.getDate()
        },
        jsdate: dpValue
      };

      this.dt = selectedDate;
      this.isSlotSelected.emit(true);

      if (this.selectionMode == 'start') {
        this.SelectedStartDate.emit(selectedDate);
      }

      if (this.selectionMode == 'end') {
        this.SelectedEndDate.emit(selectedDate);
      }
    }
  }

  /* Prevent calendar from closing on popover component */
  public onCalendarClose(event: kendo.ui.DatePickerCloseEvent) {
    if (this.preventCloseOnSelect) {
      setTimeout(() => {
        if (this.preventClose) {
          event.sender.open();
        }
        this.preventClose = false;
      }, 500);
    }
  }

  /* Reset the option on any chnage in model */
  ngOnChanges(changes: SimpleChanges) {
    if (this.selectionMode == 'start') {
      this.options = this.myStartOptions;
    }
    else {
      this.options = this.myEndOptions;
    }

    let kendoDatePicker = $(`#${this.id}`).data("kendoDatePicker");

    if (!!kendoDatePicker) {
      let selectedDate = this.getSelectedDate();

      kendoDatePicker.setOptions({
        min: this.options.min,
        max: this.options.max,
        format: this.options.format,
        value: selectedDate,
        dateInput: true,
        start: this.options.start,
        disableDates: this.options.disableDates,
        messages: {
          dateInput: {
            year: "YYYY",
            month: "MM",
            day: "DD"
          }
        },
        footer: false
      });

      kendoDatePicker.value(selectedDate);

      kendoDatePicker.enable(!this.disabled);
      $(`#${this.id}`).siblings('button').attr('aria-label', `${this.datepickerBtnAriaLblText}`);
    }
  }

  // Sync datepicker value with selected date if value is invalid when losing focus
  onBlur($event: any): void {
    let input: HTMLInputElement = this.datepickerInput.nativeElement;
    let kendoDatePicker = $(`#${this.id}`).data("kendoDatePicker");

    if (!!kendoDatePicker) {
      if (!input.validity.valid) {
        kendoDatePicker.value(this.getSelectedDate());
      } else {
        // Hack to sync selected date with value in the input field, since the datepicker is not firing the change event on its own when clamping to min/max
        setTimeout(() => {
          let splitInput = input.value.split('/');

          let inputYear: number;
          let inputMonth: number;
          let inputDay: number;
          let inputDate: Date;

          if (splitInput.length === 3) {
            if (this.options.format == 'dd/MM/yyyy') {
              [inputDay, inputMonth, inputYear] = splitInput.map(value => parseInt(value));
            } else if (this.options.format == 'yyyy/MM/dd') {
              [inputYear, inputMonth, inputDay] = splitInput.map(value => parseInt(value));
            } else {
              [inputMonth, inputDay, inputYear] = splitInput.map(value => parseInt(value));
            }

            inputDate = new Date(inputYear, inputMonth - 1, inputDay, 0, 0, 0, 0);
          }

          if (!!inputDate && (!kendoDatePicker.value() || (!!kendoDatePicker.value() && inputDate.valueOf() !== kendoDatePicker.value().valueOf()))) {
            kendoDatePicker.value(inputDate);
            kendoDatePicker.trigger("change");
          }
        });
      }
    }
  }

  getSelectedDate(): Date {
    return !!this.activeDate && !!this.activeDate['jsdate'] ? this.activeDate['jsdate'] : null;
  }

  getRegex(): string {
    return regex.date;
  }

  public describedByText(): string {
    return !!this.describedBy ? this.describedBy : '';
  }
}
